export default {
  eyebrow: 'Portale partner',
  title: 'Account',
  description: 'I dettagli del tuo account partner.',
  page: {
    read_only_notice: 'Sola lettura. Clicca Modifica per cambiare un valore.',
    editing_notice: 'Modifica in corso — le modifiche sono visibili al tuo team e ai clienti.',
  },
  profile: {
    form: {
      name: {
        label: 'Nome partner',
        hint: 'Il nome legale/entità. Utilizzato nei documenti di fatturazione.',
      },
      display_name: {
        label: 'Nome visualizzato ai consumatori',
        hint: "L'etichetta «Powered by ___» che i tuoi clienti vedono nei tuoi ristoranti. Di default è il nome partner se lasciato vuoto.",
      },
      support_email: {
        label: 'Email di contatto',
        hint: 'Dove FoodAmigos e i tuoi clienti possono contattarti. La tua email di accesso rimane invariata.',
      },
      invoicing_emails: {
        label: 'E-mail per le fatture',
        hint: "Le ricevute delle fatture addebitate a te vengono inviate a ciascuno di questi indirizzi. Lascia vuoto per usare l'e-mail di accesso.",
        placeholder: 'La tua e-mail di accesso',
      },
    },
  },
  buttons: {
    edit: 'Modifica',
    cancel: 'Annulla',
    save: 'Salva',
  },
  toasts: {
    load_error: "Impossibile caricare i dettagli dell'account.",
    failed_to_save_changes: 'Salvataggio modifiche non riuscito',
    changes_got_saved: 'Modifiche salvate',
  },
};
